module.exports = __webpack_public_path__ + "img/繳費靈.375e31a4.png";